//
// Old way: TODO: migrate to flow syntax on /flow/directory
//

exports.SuccessCallback = Function; // (json:Object) => void;
exports.FailureCallback = Function; // (apiError: ApiError) => void;

exports.Moment = Object; // moment object

// To specify the enum (see BookingConstants#BookingPeriod)
exports.BookingPeriod = Number;



// WEBPACK FOOTER //
// ./sdk/scripts/utils/Types.js